module.exports = __webpack_public_path__ + "img/bgabout-old.f47fab4e.svg";